<template>
  <div class="part2-main-task">
    <div class="task-header">
      <div class="task-avatar btns" @click="showTitle"></div>
      <div class="task-content">
        <div>
          <span class="task-content-title"
            >我的積分：{{ lotteryAndTaskState.totalScore }}</span
          >
          <span class="task-content-detail btns" @click="showScoreDetail"
            >查看積分明細 >></span
          >
        </div>
        <div>
          <span class="task-content-title"
            >目前稱號：<span
              class="task-content-main"
              :style="`color: ${scoreName[realScoreLevel].color}`"
              >{{ scoreName[realScoreLevel].title }}</span
            ></span
          >
        </div>
        <div class="scorc-progress-container">
          <div class="scorc-progress">
            <i
              class="scorc-progress-icon"
              :style="{ width: `${realScoreProgress * 100}%` }"
            ></i>
            <i
              class="score-point"
              :class="{ active: realScoreLevel >= 50 }"
              style="left: 25%"
              ><span>50</span></i
            >
            <i
              class="score-point"
              :class="{ active: realScoreLevel >= 100 }"
              style="left: 50%"
              ><span> 100</span></i
            >
            <i
              class="score-point"
              :class="{ active: realScoreLevel >= 300 }"
              style="left: 80%"
              ><span>300</span></i
            >
          </div>
        </div>
      </div>
    </div>
    <div class="task-list">
      <div
        class="task-list-item"
        v-for="(item, index) in taskList"
        :key="item.key"
        :class="{
          finish: isShowFinish(item),
          end: lotteryAndTaskState.isEnd,
        }"
      >
        <i class="task-list-item-icon">{{ index + 1 }}</i>
        <div class="task-list-item-content">
          <div class="task-list-item-content-title">{{ item.title }}</div>
          <div class="task-list-item-content-descript">
            {{ getCurDescript(item) }}
          </div>
        </div>
        <div class="task-btn btns" @click="handleTaskBtn(item)">
          {{ taskBtnText(item) }}
        </div>
      </div>
    </div>
    <div class="task-footer">
      <div class="task-rule" @click="showRule">
        活動規則<i class="task-footer-icon"></i>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject, reactive, computed, ref } from "vue";
import { taskText } from "@config";
import { UgcTab } from "../typings";

const lotteryAndTaskState = inject("lotteryAndTaskState", reactive({}));
const v3PopupState = inject("v3PopupState", reactive({}));
const checkLogin = inject("checkLogin");
const submitTask = inject("submitTask");
const gotoLogin = inject("gotoLogin");
const isLogin = inject("isLogin");
const activeUgcTab = inject("activeUgcTab", ref(UgcTab.UgcTypeMyROMemory));
const goUgcList = inject("goUgcList");
const goCenter = inject("goCenter");
const showFeedbackPopup = inject("showFeedbackPopup");
const initActivity = inject("initActivity");
const showTipMessage = inject("showTipMessage");

const canClick = ref(true);

const scoreName = {
  0: {
    title: "無",
    color: "",
  },
  50: {
    title: "初心者腦洞好大喔",
    color: "",
  },
  100: {
    title: "RO大世界入股不虧",
    color: "#cc5a00",
  },
  300: {
    title: "不裝了我是創世神",
    color: "#cd176c",
  },
};

const taskList = computed(() => {
  return taskText.map((item) => {
    return {
      ...item,
      state: lotteryAndTaskState[item.key].state || 0,
      progress: lotteryAndTaskState[item.key].progress || "",
    };
  });
});

const realScoreLevel = computed(() => {
  if (lotteryAndTaskState.historyScore < 50) {
    return 0;
  }
  if (
    lotteryAndTaskState.historyScore < 100 &&
    lotteryAndTaskState.historyScore >= 50
  ) {
    return 50;
  }
  if (
    lotteryAndTaskState.historyScore < 300 &&
    lotteryAndTaskState.historyScore >= 100
  ) {
    return 100;
  }

  return 300;
});

const realScoreProgress = computed(() => {
  const score = lotteryAndTaskState.historyScore;
  if (score > 350) {
    return 1;
  }
  if (score <= 50) {
    return (score * 0.25) / 0.5 / 100;
  }
  if (score > 50 && score <= 100) {
    let _s = score - 50;
    return (25 + (_s * 0.25) / 0.5) / 100;
  }
  // 100-300之间，总进度是80%-50%
  if (score > 100 && score <= 300) {
    let _s = score - 100;
    return (50 + (_s * 0.3) / 2) / 100;
  }
  if (score > 300 && score <= 350) {
    let _s = score - 300;
    return (80 + (_s * 0.2) / 0.5) / 100;
  }
});

const showTitle = () => {
  v3PopupState.titlePopupState = true;
  lotteryAndTaskState.titlePopup.title = scoreName[realScoreLevel.value].title;
  lotteryAndTaskState.titlePopup.color = scoreName[realScoreLevel.value].color;
};

const getCurDescript = (item) => {
  if (item.progress !== void 0) {
    return item.descript.replace("{n}", item.progress || 0);
  }
  return item.descript;
};

const isShowFinish = (config) => {
  if (
    config.state === 2 &&
    (config.key == "joinLine" ||
      config.key == "joinYtb" ||
      config.key == "joinDc" ||
      config.key == "joinFb" ||
      config.key == "dailyLogin" ||
      config.key == "advanceReservation")
  ) {
    return true;
  }
  return false;
};

const taskBtnText = computed(() => {
  return (item) => {
    if (lotteryAndTaskState.isEnd) {
      return "已结束";
    }
    if (isShowFinish(item)) {
      return "已完成";
    }
    return "立即前往";
  };
});

const showScoreDetail = () => {
  if (!checkLogin()) {
    return;
  }
  window.activityDataLayer.push({
    eventName: "click_button",
    eventType: "积分明细",
    eventReason: "首页",
    aid: window.activity_name,
    gameId: window.game_id,
  });
  window.activityDataLayer.push({
    eventName: "show_popup",
    eventType: "积分明细",
    aid: window.activity_name,
    gameId: window.game_id,
  });
  v3PopupState.scoreDetailPopupState = true;
};

const handleTaskBtn = async (item) => {
  if (item.login && !isLogin.value) {
    gotoLogin();
    return;
  }
  if (!checkLogin()) {
    return;
  }
  if (isShowFinish(item)) {
    return;
  }
  if (!canClick.value) {
    return;
  }
  canClick.value = false;
  if (item.callbackKey) {
    submitTask(item.callbackKey).then(() => {
      initActivity();
    });
  }
  if (item.redirectUrl) {
    let curLink =
      item.key == "advanceReservation"
        ? window.globalGetGotoLink({ link: item.redirectUrl })
        : item.redirectUrl;
    window.open(curLink, "_blank");
  }
  if (item.ugcTab) {
    activeUgcTab.value = item.ugcTab;
    goUgcList(item.autoOpen);
  }
  if (item.centerTab) {
    goCenter();
  }
  if (item.feedbackPopup) {
    showFeedbackPopup();
  }
  canClick.value = true;
};

const showRule = () => {
  window.activityDataLayer.push({
    eventName: "click_button",
    eventType: "规则说明",
    eventReason: "首页",
    aid: window.activity_name,
    gameId: window.game_id,
  });
  window.activityDataLayer.push({
    eventName: "show_popup",
    eventType: "规则说明",
    aid: window.activity_name,
    gameId: window.game_id,
  });
  v3PopupState.taskPopupState = true;
};
</script>

<style scoped lang="less"></style>
